export enum NEXT_API_PATHS {
  getVersion = '/api/getVersion',
}
